import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

//service
import { LoginService } from '../common/services/login.service';

// model

import { Ticket } from '../models/ticket';

const ELEMENT_VENTA: Ticket[] = [];

declare var jQuery: any;
declare var $: any;


@Component({
  selector: 'app-my-dialog-cotizacion',
  templateUrl: './my-dialog-cotizacion.component.html',
  styleUrls: ['./my-dialog-cotizacion.component.css']
})

export class MyDialogCotizacionComponent{ 

  

  displayedColumnsVenta: string[] = ['dessucursal', 'serie', 'numdoc', 'nomcom', 'total', 'feccre','symbol'];
  dataSourceVenta = ELEMENT_VENTA;

  constructor(      
      private _loginService: LoginService,      
      public thisDialogRef: MatDialogRef<MyDialogCotizacionComponent>,
       @Inject(MAT_DIALOG_DATA) public data: string) { }

    /*onCloseConfirm() {        
          localStorage.clear();
            this.thisDialogRef.close('Confirm');

    }*/
  

  /*onCloseCancel() {
     this.thisDialogRef.close('Cancel');
  }*/
  
    consultaRegCotizacion(searchValue: string) {
      console.log("consultaRegCotizacion"); 
      
      $("#searchPop").select();
      var tipoFecha ='0';      
   
      this._loginService.listaProforma(tipoFecha, searchValue).subscribe(
        response => {
          console.log("L I S T A   C O T I Z A C I O N");
          console.log(response);
          this.dataSourceVenta = response.data;
          console.log("this.dataSourceVenta:" + this.dataSourceVenta);

        },
        error => {
          console.log(<any>error);
          //console.log("error 454545.");
          var errorMessage = <any>error;
          if (errorMessage != null) {
            var body = JSON.parse(error._body);            
          }
        }
      )
 

  }  

}